import { apiClient } from './client';
import type { DashboardStats, RecentOrder } from './types';

interface DashboardParams {
  channelId?: string;
}

interface MigrationResult {
  storeHash: string;
  migrationsApplied: string[];
  message: string;
}

export const dashboardApi = {
  async getStats(params?: DashboardParams): Promise<DashboardStats> {
    const queryParams = new URLSearchParams();
    if (params?.channelId) {
      queryParams.set('channelId', params.channelId);
    }
    const query = queryParams.toString();
    return apiClient.request<DashboardStats>(`/dashboard/stats${query ? `?${query}` : ''}`);
  },

  async getRecentOrders(params?: DashboardParams): Promise<{ orders: RecentOrder[] }> {
    const queryParams = new URLSearchParams();
    if (params?.channelId) {
      queryParams.set('channelId', params.channelId);
    }
    const query = queryParams.toString();
    return apiClient.request<{ orders: RecentOrder[] }>(`/dashboard/orders${query ? `?${query}` : ''}`);
  },

  async runMigrations(): Promise<MigrationResult> {
    return apiClient.request<MigrationResult>('/dashboard/migrate', {
      method: 'POST',
    });
  },
};
